export default __webpack_public_path__ + "static/media/vinivini.c7d4dbd9.mp4";